import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useAppText } from "@/contexts/AppTextContext";
import { ArrowLeft } from "lucide-react";

const LOGO_TAG = "https://customer-assets.emergentagent.com/job_belajar-usaha/artifacts/40t1ulzr_logo%20warna%202.png";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function LoginPage() {
  const { user } = useAuth();
  const { t } = useAppText();

  if (user) {
    window.location.replace("/dashboard");
    return null;
  }

  const googleLoginUrl = `${process.env.REACT_APP_BACKEND_URL}/api/auth/google/login`;

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4 py-12 relative overflow-hidden">
      <div className="absolute -top-32 -right-32 w-[400px] h-[400px] rounded-full bg-[#6B21A8] opacity-30 blur-3xl" />
      <div className="absolute -bottom-32 -left-32 w-[400px] h-[400px] rounded-full bg-[#FF8C00] opacity-20 blur-3xl" />

      <div className="relative w-full max-w-md card-surface p-8 sm:p-10 animate-fade-up" data-testid="login-card">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#5C5868] hover:text-[#1A1422] mb-6" data-testid="login-back-link">
          <ArrowLeft className="w-4 h-4" /> {t("login.back_link")}
        </Link>
        <img src={LOGO_TAG} alt="BisaUsaha" className="h-16 mb-6" />
        <h1 className="font-heading text-3xl font-extrabold text-[#1A1422] mb-2">{t("login.title")}</h1>
        <p className="text-[#5C5868] mb-8 text-sm">{t("login.subtitle")}</p>

        <a
          href={googleLoginUrl}
          className="w-full flex items-center justify-center gap-3 bg-white hover:bg-gray-100 text-[#0D0A10] font-semibold py-3 px-6 rounded-full transition-all"
          data-testid="google-login-button"
        >
          <svg className="w-5 h-5" viewBox="0 0 48 48">
            <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8a12 12 0 1 1 0-24c3 0 5.7 1.1 7.8 3l5.7-5.7C33.6 6.3 29 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.2-.1-2.4-.4-3.5z"/>
            <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8c1.8-4.4 6-7.5 11.1-7.5 3 0 5.7 1.1 7.8 3l5.7-5.7C33.6 6.3 29 4 24 4 16.4 4 9.8 8.4 6.3 14.7z"/>
            <path fill="#4CAF50" d="M24 44c5 0 9.5-1.9 12.9-5l-6-5.1c-2 1.4-4.4 2.3-6.9 2.3-5.2 0-9.6-3.3-11.2-8l-6.5 5C9.6 39.6 16.3 44 24 44z"/>
            <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.2 4.3-4.1 5.8l6 5.1C40.5 35.7 44 30.3 44 24c0-1.2-.1-2.4-.4-3.5z"/>
          </svg>
          {t("login.google_button")}
        </a>

        <div className="mt-8 pt-6 border-t border-[#E8E5EE] text-xs text-[#8B8794] text-center">
          {t("login.terms_note")}
        </div>
      </div>
    </div>
  );
}
